import React, { useContext, useEffect, useState } from 'react';
import { CollectionSettingsDataContext } from '../contextProvider';
import { BLOCK_ELEMENT_KEY } from '../../../types';
import EditorTool from '../../../EditorTool';
import { CollectionSettingsPathContext } from '../../../context/CollectionSettingsContextProvider/pathContext';
import SelectCollectionViewFields from '../../../../CollectionSettingsComponents/SelectCollectionViewFields';
import { updateCollectionTemplateLabel } from '../../../../../utils/updateTemplateLabel';
import { deleteCollectionTemplateLabel } from '../../../../../utils/deleteTemplateLabel';
import { useTEditorRef } from '../../../plate';

function FieldsNotion() {
  const editor = useTEditorRef();
  const [newSchema, setnewSchema] = useState({});
  const {
    collectionData,
    columns,
    listColumns,
    element,
    grabElement,
    editorSyncData,
    loadingListColumns,
    err,
  } = useContext(CollectionSettingsDataContext);
  const path = useContext(CollectionSettingsPathContext);
  const [template, settemplate] = useState(element?.[BLOCK_ELEMENT_KEY.COLLECTION_TEMPLATE]);
  useEffect(() => {
    listColumns(collectionData);
  }, [collectionData]);

  const updateSchema = async () => {
    const blockTemplate = { ...template };
    blockTemplate.schema = newSchema;
    EditorTool.setBlockProperty(
      editor,
      BLOCK_ELEMENT_KEY.COLLECTION_TEMPLATE,
      blockTemplate,
      {
        at: path,
      },
    );
    grabElement(path);
    await editorSyncData(collectionData);
  };

  const updateSchemaLabel = (oriLabel: string, newLabel: string) => {
    setnewSchema((prev) => {
      const updatedSchema = { ...prev };
      const val = updatedSchema[oriLabel];
      updatedSchema[oriLabel] = undefined;

      if (Object.prototype.hasOwnProperty.call(updatedSchema, oriLabel)) {
        delete updatedSchema[oriLabel];
      }
      updatedSchema[newLabel] = val;
      return updatedSchema;
    });

    const newTemplate = updateCollectionTemplateLabel(template, oriLabel, newLabel);
    settemplate(newTemplate);
  };

  const deleteSchemaLabel = (label: string) => {
    setnewSchema((prev) => {
      const updatedSchema = { ...prev };
      updatedSchema[label] = undefined;

      if (Object.prototype.hasOwnProperty.call(updatedSchema, label)) {
        delete updatedSchema[label];
      }
      return updatedSchema;
    });

    const newTemplate = deleteCollectionTemplateLabel(template, label);
    settemplate(newTemplate);
  };

  const onCancel = () => {
    settemplate(element?.[BLOCK_ELEMENT_KEY.COLLECTION_TEMPLATE]);
    setnewSchema(element?.[BLOCK_ELEMENT_KEY.COLLECTION_TEMPLATE]?.schema);
  };
  useEffect(() => {
    onCancel();
  }, [element?.[BLOCK_ELEMENT_KEY.COLLECTION_TEMPLATE]]);

  return (
    <SelectCollectionViewFields
      collectionData={collectionData}
      columns={columns}
      listColumns={listColumns}
      element={element}
      template={template}
      updateSchema={updateSchema}
      showSaveFields
      showResetFields={false}
      newSchema={newSchema}
      setnewSchema={setnewSchema}
      loadingListColumns={loadingListColumns}
      showFieldsConnected={false}
      updateSchemaLabel={updateSchemaLabel}
      originalSchema={element?.[BLOCK_ELEMENT_KEY.COLLECTION_TEMPLATE]?.schema}
      deleteSchemaLabel={deleteSchemaLabel}
      err={err}
      onCancel={onCancel}
    />
  );
}

export default FieldsNotion;
